import React from 'react';
import { Button, Input, Modal, message } from 'antd';
import { MSG_OWNER_COPY as C } from '../copy';
import s from '../s.module.less';

type Props = {
    open: boolean;
    // 预填草稿（被卡住那一刻空白输入框只会让人关掉弹窗）
    draft: string;
    onClose: () => void;
};

// member 被 payer gap 卡住时的人工通道。发送是 mock 占位——
// TODO(eligibility): 给 owner 的站内通知走什么通道待后端定（收件人是 provider 不是患者，
// NewMessagePanel 的 fixedRecipient 不适用）
const MessageOwnerModal: React.FC<Props> = ({ open, draft, onClose }) => {
    const [text, setText] = React.useState(draft);

    React.useEffect(() => {
        if (open) setText(draft);
    }, [open, draft]);

    return (
        <Modal
            open={open}
            onCancel={onClose}
            title={C.title}
            width={480}
            wrapClassName={s.eligModalScope}
            footer={
                <div className={s.costFooterBtns}>
                    <Button onClick={onClose}>Cancel</Button>
                    <Button
                        type="primary"
                        disabled={!text.trim()}
                        onClick={() => {
                            message.success(C.sent);
                            onClose();
                        }}
                    >
                        {C.send}
                    </Button>
                </div>
            }
        >
            <div className={s.npiIntro}>To: {C.to}</div>
            <Input.TextArea value={text} onChange={(e) => setText(e.target.value)} autoSize={{ minRows: 4 }} />
        </Modal>
    );
};

export default MessageOwnerModal;
